import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value", "placeholder"]
const _hoisted_2 = { class: "upload-icon" }

import InputWrapperWithIcon from "~/chat/vue/widget/form/fields/InputWrapperWithIcon.vue";
import ChatUpload from "~/chat/vue/widget/form/ChatUpload.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import ChatUploadHelper from "~/chat/ts/service/ChatUploadHelper";
import {ITextareaField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatTextInputSuggest from "~/chat/vue/widget/form/fields/ChatTextInputSuggest.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed, getCurrentInstance, nextTick, onMounted, ref, watch} from "vue";


const __default__ = {
    name: "ChatTextareaInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<ITextareaField>(),
    uploadIsListening: {type: Boolean}
},
  emits: ["update:modelValue", "upload"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

let instance = getCurrentInstance().proxy;
let scrollbarWidth = ref(0);

let isUploadAvailable = computed(() => {
    return !!props.field.upload;
});

function onFileUploaded(files: IChatUploadFile[]) {
    if (props.uploadIsListening) {
        emits("upload", files);
    } else {
        let value: string = props.modelValue ? props.modelValue : "";
        for (let file of files) {
            if (value.length) {
                value += "\n";
            }
            value += ChatUploadHelper.fileToString(file);
        }
        emits("update:modelValue", value);
        nextTick(() => {
            computeScrollbarWidth();
        });
    }
}

onMounted(() => {
    computeScrollbarWidth();
});

let input = ref<HTMLElement>()

function computeScrollbarWidth() {
    let borderWidth = parseInt(getComputedStyle(input.value).borderWidth);
    let newScrollbarWidth = input ? input.value.offsetWidth - input.value.clientWidth : 0;

    if (!isNaN(borderWidth)) {
        newScrollbarWidth -= borderWidth * 2;
    }

    scrollbarWidth.value = newScrollbarWidth;
}

watch(computed(() => props.modelValue), () => computeScrollbarWidth());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputWrapperWithIcon, {
    field: _ctx.field,
    required: _ctx.required,
    "scrollbar-width": _unref(scrollbarWidth)
  }, {
    default: _withCtx(() => [
      _createVNode(ChatTextInputSuggest, {
        field: _ctx.field,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
        "model-value": _ctx.modelValue
      }, {
        default: _withCtx(() => [
          _createElementVNode("textarea", {
            value: _ctx.modelValue,
            ref_key: "input",
            ref: input,
            class: _normalizeClass([{ 'with-upload': _unref(isUploadAvailable), error: _ctx.error, 'with-icon': _ctx.field.icon, 'ym-disable-keys': true }, "textarea"]),
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event.target.value))),
            placeholder: _unref(placeholder),
            "data-gramm": "false"
          }, null, 42, _hoisted_1)
        ]),
        _: 1
      }, 8, ["field", "model-value"]),
      (_unref(isUploadAvailable))
        ? (_openBlock(), _createBlock(ChatUpload, {
            key: 0,
            onNewFiles: onFileUploaded,
            class: "upload-handler",
            style: _normalizeStyle({ marginRight: `${_unref(scrollbarWidth)}px !important`})
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SvgIcon, {
                  class: "text-muted",
                  "icon-name": "paperclip"
                })
              ])
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["field", "required", "scrollbar-width"]))
}
}

})